import { FileValidationRule } from './file-validation-rule';

export class FiletypeValidationRule implements FileValidationRule {
    private readonly VALID_FILE_TYPES: string[] = ['application/pdf', 'image/png', 'image/jpeg', 'image/bmp'];

    public readonly errorKey = 'invalidDatatype';

    public validate(file: File): boolean {
        const lowerCaseFiletype = file.type.toLowerCase();
        return this.VALID_FILE_TYPES.includes(lowerCaseFiletype);
    }
}
